import { render, staticRenderFns } from "./SyllabusEffectsButtonAdminActions.vue?vue&type=template&id=441914bc&scoped=true&"
import script from "./SyllabusEffectsButtonAdminActions.vue?vue&type=script&lang=js&"
export * from "./SyllabusEffectsButtonAdminActions.vue?vue&type=script&lang=js&"
import style0 from "./SyllabusEffectsButtonAdminActions.vue?vue&type=style&index=0&id=441914bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441914bc",
  null
  
)

export default component.exports